<plex-title titulo="Historial de movimientos" size="md">
    <plex-button size="sm" type="danger" icon="close" tooltip="Cerrar" (click)="onClose()"></plex-button>
</plex-title>

<div *ngIf="!agenda?.historial.length" class="h-50" justify="center">
    <plex-label icon="calendar-clock" size="md" direction="column" [tituloBold]="false"
                titulo="Aún no hay un historial registrado" subtitulo="">
    </plex-label>
</div>

<table *ngIf="agenda?.historial.length" class="table">
    <thead>
        <tr>
            <th>FECHA</th>
            <th class="pl-5">PRESTACIÓN</th>
            <th class="text-center">ESTADO</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let item of agenda?.historial">
            <td>
                {{ item.createdAt | fecha:'dd/MM/yyyy HH:mm' }} hs
            </td>
            <td>
                {{ agenda.tipoPrestaciones | enumerar: ['nombre'] }}
            </td>
            <td class="text-center">
                <plex-badge [type]="type(item.estado)">{{item.estado}}</plex-badge>
            </td>
        </tr>
    </tbody>
</table>